import type { ReactNode } from "react";
import { Text, View } from "react-native";

export function Badge({
  status,
  dot = false,
  children,
}: {
  status: "success" | "amber" | "grey" | "red" | "info";
  dot?: boolean;
  children: ReactNode;
}) {
  const cls =
    status === "success"
      ? "bg-success/10 border-success/30 text-success"
      : status === "amber"
        ? "bg-amber/10 border-amber/30 text-amber"
        : status === "red"
          ? "bg-error/10 border-error/30 text-error"
          : status === "info"
            ? "bg-blue-50 border-blue-200 text-blue-700"
            : "bg-text/5 border-text/15 text-text/60";
  const dotCls =
    status === "success"
      ? "bg-success"
      : status === "amber"
        ? "bg-amber"
        : status === "red"
          ? "bg-error"
          : status === "info"
            ? "bg-blue-600"
            : "bg-text/40";
  return (
    <View className={`inline-flex flex-row items-center gap-1.5 rounded-pill border px-3 py-1 ${cls}`}>
      {dot ? <View className={`h-[5px] w-[5px] rounded-full ${dotCls}`} /> : null}
      <Text className="text-[10px] font-bold uppercase tracking-[0.18em]">{children}</Text>
    </View>
  );
}
